import styled from 'styled-components';

export const ScrollToTopLink = styled.a`
    @media screen and (max-width: ${props => props.theme.mobile}) {
        display: block;
        visibility: visible;
        opacity: 1;
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        background-color: rgba(204, 204, 204, 1);
        border-radius: 3px;
        padding: 8px 0;
        cursor: pointer;
        text-align: center;
        transition: opacity 0.2s linear, background 0.2s cubic-bezier(0.16, 0.49, 0.42, 0.99);

        &.hidden {
            visibility: hidden;
            opacity: 0;
        }

        &:hover {
            background-color: rgba(204, 204, 204, 0.8);
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/ScrollToTopComponentStyle.js